import classNames from 'classnames'
import React, { FC } from 'react'
import styles from 'styles/components/typography.module.scss'

type Props = {
  caution: string
  dataCy?: string
  isBold?: boolean
  size?: 'small' | 'medium' | 'large'
}

const Caution: FC<Props> = (props) => {
  const { caution, dataCy = 'default', isBold = true, size = 'medium' } = props

  return (
    <p
      className={classNames({
        [styles.description_caution_small]: size === 'small',
        [styles.description_caution_large]: size === 'large',
        [styles.description_caution_bold]: isBold,
        [styles.description_caution]: true,
      })}
      data-cy={`caution-${dataCy}`}
    >
      {caution}
    </p>
  )
}

export default Caution
